module.exports = __webpack_public_path__ + "media/images/リピート割引_500円_1280_480-07605ff9a7a6039a4bf4f8e8b7fd3d4c.png";